export { default } from './BustiaDenuncia';
